import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { StartingRoomProps } from '../interfaces/components';
import StartingTerraceImage from '../assets/images/StartingTerrace.png';
import StartingIndoorImage from '../assets/images/StartingIndoor.png';
import { StartingRoomModal } from '../content';
import StartingRoomItem from '../components/StartingRoom/StartingRoomItem';

const StartingRoom = ({ activeLocale, active, setActive }: StartingRoomProps) => {
  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.5)"
        transition="all 1s"
        zIndex="14"
        onClick={() => {
          window.GotoScene('ramadan_0');
          setActive('ramadan_0');
        }}
      />

      <Box
        zIndex="15"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['90vw', '380px', '500px', '650px', '700px']}
        height={['450px', '500px', '550px', '500px', '550px']}
      >
        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-evenly"
          alignItems="center"
          height="100%"
        >
          <Box w={['90%', '90%', '100%', '100%']} display="flex" justifyContent="center" alignItems="center">
            <Text
              textAlign="center"
              w="auto"
              fontSize={['20px', '25px', '30px', '35px', '40px']}
              lineHeight={['20px', '25px', '30px', '35px', '40px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
              fontWeight="500"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                ? StartingRoomModal['en'].start
                : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].start}
            </Text>
          </Box>

          <Box
            w={['90%', '340px', '360px', '500px', '500px']}
            height={['300px', '310px', '320px', '300px', '330px']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'row']}
            justifyContent="space-between"
            alignItems="center"
          >
            <StartingRoomItem
              gotoRoom="ramadan_0"
              name="indoor"
              activeLocale={activeLocale}
              textOne={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].indoor.textOne
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].indoor.textOne
              }
              textTwo={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].indoor.textTwo
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].indoor.textTwo
              }
              textThree={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].indoor.textThree
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].indoor.textThree
              }
              textFour={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].indoor.textFour
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].indoor.textFour
              }
              imageUrl={StartingIndoorImage}
              button={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].indoor.button
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].indoor.button
              }
              setActive={() => setActive('ramadan_0')}
            />

            <StartingRoomItem
              gotoRoom="ramadan_17"
              name="terrace"
              activeLocale={activeLocale}
              textOne={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].terrace.textOne
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].terrace.textOne
              }
              textTwo={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].terrace.textTwo
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].terrace.textTwo
              }
              textThree={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].terrace.textThree
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].terrace.textThree
              }
              textFour={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].terrace.textFour
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].terrace.textFour
              }
              imageUrl={StartingTerraceImage}
              button={
                activeLocale === undefined || !((activeLocale as keyof typeof StartingRoomModal) in StartingRoomModal)
                  ? StartingRoomModal['en'].terrace.button
                  : StartingRoomModal[activeLocale as keyof typeof StartingRoomModal].terrace.button
              }
              setActive={() => setActive('ramadan_17')}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default StartingRoom;
